export default "__VITE_ASSET__D7CANq_3__"